/* unplugin-vue-components disabled */import { render } from "./users.vue?vue&type=template&id=d673cd32"
import script from "./users.vue?vue&type=script&lang=js"
export * from "./users.vue?vue&type=script&lang=js"

import "./users.vue?vue&type=style&index=0&id=d673cd32&lang=stylus"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/tenant/users.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d673cd32"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d673cd32', __exports__)) {
    api.reload('d673cd32', __exports__)
  }
  
  module.hot.accept("./users.vue?vue&type=template&id=d673cd32", () => {
    api.rerender('d673cd32', render)
  })

}


export default __exports__